import { useSWRConfig } from 'swr';
import { isCompletePet } from '@web/onboarding/OnboardingFlowContainer/guard';
import { useShopifyCartContext } from '@web/onboarding/OnboardingFlowContainer/ShopifyCartProvider';
import { EMPTY_PET } from '@web/pets';

export const useShopifyPet = petId => {
  const { cart, addPetData } = useShopifyCartContext();
  const { mutate: globalMutate, cache } = useSWRConfig();

  const getPet = id => (id && cart.pets?.find(pet => pet.id === id)) ?? null;

  const savePet = async values => {
    const existingPet = getPet(petId);

    const updatedPetData = existingPet
      ? {
          id: existingPet.id ?? null,
          name: existingPet.name ?? null,
          is_neutered: existingPet.is_neutered ?? null,
          weight: existingPet.weight ?? null,
          ideal_weight: existingPet.ideal_weight ?? null,
          gender: existingPet.gender ?? null,
          activity_level: existingPet.activity_level ?? null,
          ...values,
        }
      : values;

    const currentCart = await addPetData(updatedPetData);

    const pet =
      currentCart.pets?.find(p => p.id === petId) ??
      currentCart.pets?.find(pet => !isCompletePet(pet));

    if (pet) {
      const planTypesUrl = `/api/v4/onboarding/${cart.cart_id}/pets/${petId}/plans/`;
      const cacheKeys = Array.from(cache.keys());
      const matchingKeys = cacheKeys.filter(
        key => typeof key === 'string' && key === planTypesUrl,
      );
      if (matchingKeys.length > 0) {
        matchingKeys.forEach(key => {
          // synchronizes meal plan combinations with the pet update
          globalMutate(key);
        });
      }
    }

    return {
      status: 200,
      data: { pet, pets: currentCart.pets, cart: currentCart },
    };
  };

  return {
    pet: getPet(petId) || EMPTY_PET,
    isLoading: false,
    savePet,
  };
};
